import VideoPlayer from "@/components/Onboarding/GuidedVideo/VideoPlayer";

function VideoPlayerPage() {
  return <VideoPlayer />;
}

export default VideoPlayerPage;
